<template>
  <View v-if="text" direction="column" gap="xs" class="notes">
    <Text variant="label-small" color="secondary">{{ label }}</Text>
    <Text variant="body-medium" class="text">{{ text }}</Text>
  </View>
</template>

<script setup lang="ts">
import { Text, View } from '@tallo/design-system';

/** Free text under a card's rows; nothing at all when there is none */
withDefaults(defineProps<{ text?: string | null; label?: string }>(), { text: null, label: 'Notes' });
</script>

<style scoped lang="scss">
.notes {
  // Last in its card, and pinned to the bottom when a neighbour stretches the row
  margin-top: auto;
  padding-left: 0.75rem;
  border-left: 2px solid var(--t-color-border-secondary);
}

// Notes are typed with line breaks; they read the way they were written
.text {
  white-space: pre-line;
}
</style>
